"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticStyles = exports.selectFlexStyles = void 0;
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectFlexStyles = _ref => {
  let {
    alignItems,
    justifyContent,
    flexGrow,
    flexShrink
  } = _ref;
  return {
    alignItems,
    justifyContent,
    flexGrow,
    flexShrink
  };
};
exports.selectFlexStyles = selectFlexStyles;
const staticStyles = exports.staticStyles = _StyleSheet.default.create({
  wrap: {
    flexShrink: 1,
    flexWrap: 'wrap'
  },
  row: {
    flexDirection: 'row'
  },
  'row-reverse': {
    flexDirection: 'row-reverse'
  },
  column: {
    // This is the React Native View default, but also it's very fundamental to the behaviour,
    // so make it explicit and allow it to be tested for.
    flexDirection: 'column'
  },
  'column-reverse': {
    flexDirection: 'column-reverse'
  }
});